export default {
  noDataText: 'ไม่พบข้อมูล',
  loading: 'กำลังโหลดข้อมูล...',
  isCollectingDocuments: 'กำลังรวบรวมเอกสาร',
  others: 'อื่นๆ',
  itemPerPage: 'รายการต่อหน้า',
  title: {
    medicineName: 'ชื่อยา',
    create: 'สร้างสูตรยาใหม่',
    edit: 'แก้ไขสูตรยา',
    list: 'รายการส่วนผสม',
    pill: 'ยาเม็ด',
    category: 'หมวดหมู่สูตรยา'
  },
  placeholder: {
    no: 'กรอกรหัสสูตรยา',
    quantityToOrder: 'กรอกจำนวนที่ต้องการ',
    noOrDrugNameOrDoctor: 'ค้นหารหัสสูตรยา ชื่อสูตรยา ชื่อแพทย์',
    productName: 'กรอกชื่อสินค้า',
    manageProduct: 'จัดการสินค้า',
    productNameEn: 'กรอกชื่อสินค้า (EN)',
    productNameCn: 'กรอกชื่อสินค้า (CN)',
    doctor: 'เลือกชื่อแพทย์ (เจ้าของสูตร)',
    category: 'เลือกหมวดหมู่',
    howToUse: 'กรอกวิธีใช้',
    time: 'กรอกเวลาใช้',
    preserve: 'กรอกวิธีเก็บรักษา',
    properties: 'สรรพคุณ',
    advice: 'คำแนะนำ',
    ingredient: 'เลือกส่วนผสม',
    plzIngredient: 'กรุณาเลือกส่วนผสม !',
    plzSelectData: 'โปรดเลือกข้อมูล',
    searchIdName: 'ค้นหารหัสสูตรยา, ชื่อสูตรยา',
    editCategory: 'แก้ไขหมวดหมู่สูตรยา',
    enterCategory: 'กรอกข้อมูลหมวดหมู่สูตรยา',
    searchCategory: 'ค้นหาชื่อหมวดหมู่สูตรยา',
    conditionFormula: 'กรอกเงื่อนไขสูตรยา',
    searchCondition: 'ค้นหาชื่อเงื่อนไขสูตรยา',
    plzEnterProfit: 'โปรดกรอกกำไร',
    enterProfit: 'กรอกกำไร'
  },
  header: {
    no: 'รหัสสูตรยา',
    drugName: 'ชื่อสูตรยา',
    productName: 'ชื่อสินค้า',
    doctor: 'ชื่อแพทย์',
    category: 'หมวดหมู่',
    preserve: 'วิธีเก็บรักษา',
    properties: 'สรรพคุณ',
    howToUse: 'วิธีใช้',
    selectedUsage: 'เลือกวิธีใช้',
    selectedUsageTime: 'เลือกเวลาใช้',
    selectedStorageMethod: 'เลือกวิธีเก็บรักษา',
    time: 'เวลาใช้',
    unitConversion: 'แปลงหน่วย',
    advice: 'คำแนะนำ',
    note: 'หมายเหตุ',
    status: 'สถานะ',
    price: 'ราคาขาย',
    totalPrice: 'ราคารวม'
  },
  label: {
    category: 'หมวดหมู่',
    name: 'ชื่อหมวดหมู่สูตรยา',
    nameTh: 'ชื่อสินค้า',
    nameEn: 'ชื่อสินค้า (EN)',
    nameCn: 'ชื่อสินค้า (CN)',
    doctor: 'ชื่อแพทย์ (เจ้าของสูตร)',
    properties: 'สรรพคุณ',
    howToUse: 'วิธีใช้',
    time: 'เวลาใช้',
    advice: 'คำแนะนำ',
    note: 'หมายเหตุ',
    status: 'สถานะ',
    preserve: 'วิธีเก็บรักษา',
    unit: 'หน่วย',
    quantity: 'จำนวน',
    quantityUnit: 'จำนวน หน่วย',
    condition: 'เงื่อนไข',
    price: 'ราคาขาย',
    priceFormula: 'ราคาสูตรยา',
    bath: 'บาท',
    conditionFormula: 'เงื่อนไขสูตรยา',
    editConditionFormula: 'แก้ไขเงื่อนไขสูตรยา',
    setAllProfit: 'กำหนดกำไรสำหรับสูตรยาทั้งหมด'
  },
  tooltip: {
    info: 'ดูรายละเอียด',
    detail: 'ดูข้อมูลส่วนผสม',
    edit: 'แก้ไขข้อมูล',
    delete: 'ลบข้อมูล',
    confirmDelete: 'ยืนยันการลบสูตรยา',
    confirmDeleteDetail: 'คุณกำลังลบสูตรยา ต้องการดำเนินการต่อหรือไม่ ?',
    healthCertWithHistory: 'ข้าพเจ้าขอใบรับรองสุขภาพโดยมีประวัติสุขภาพดังนี้',
    examiningDoctorStatement: 'ข้าพเจ้าแพทย์ผู้ตรวจผู้มีชื่อข้างต้นนี้ ได้ทำการตรวจร่างกายบุคคลดังต่อไปนี้',
    profitInfo1: 'กำไร ที่กรอกจะนำไปบวกเพิ่มจาก ราคารวมของส่วนผสม เป็น ราคาขายสูตรยา',
    hasConductedPhysicalExam: 'ได้ทำการตรวจร่างกาย',
    profitInfo2: 'และใช้สำหรับการนำไปแบ่งเป็น ค่าคอมมิชชั่น ให้กับ ผู้จ่ายยา',
    medicationWarning: 'หากมีปัญหาการใช้ยาปรึกษาแพทย์หรือเภสัชกรเท่านั้น',
    downloadMenuNotice: 'เอกสารของคุณกำลังถูกรวบรวม อยู่ที่เมนูรายการดาวน์โหลดเอกสารไปที่ “ตั้งค่า” และเลือก “รายการดาวน์โหลด”'

  },
  modal: {
    confirmDelete: 'ยืนยันการลบสูตรยา',
    confirmDeleteDetail: 'คุณกำลังลบสูตรยา ต้องการดำเนินการต่อหรือไม่ ?',
    deleted: 'ลบสูตรยาสำเร็จ !',
    edited: 'แก้ไขสูตรยาสำเร็จ !',
    create: {
      price: 'สร้างราคาสูตรยาสำเร็จ !',
      success: 'เพิ่มหมวดหมู่สูตรยาสำเร็จ !',
      condition: 'เพิ่มเงื่อนไขสูตรยาสำเร็จ !'
    },
    edit: {
      price: 'แก้ไขราคาสูตรยาสำเร็จ !',
      condition: 'แก้ไขเงื่อนไขสูตรยาสำเร็จ !'
    },
    delete: {
      confirm: 'ยืนยันการลบหมวดหมู่สูตรยา',
      confirmCondition: 'ยืนยันการลบเงื่อนไขสูตรยา',
      subtitle: 'คุณกำลังลบหมวดหมู่สูตรยา ต้องการดำเนินการต่อหรือไม่ ',
      subtitleCondition: 'คุณกำลังลบเงื่อนไขสูตรยา ต้องการดำเนินการต่อหรือไม่',
      success: 'ลบหมวดหมู่สูตรยาสำเร็จ !',
      condition: 'ลบเงื่อนไขสูตรยาสำเร็จ !'

    }

  },
  status: {
    dispensed: 'จัดยาแล้ว',
    waiting: 'รอจัดยา',
    returned: 'คืนยา'
  }
}
